
export default [
  {
    path: '/',
    name: 'Enrollment',
  },
  {
    path: '/terms_of_service',
    name: 'TermsOfService',
  },
  {
    path: '/new',
    name: 'EnrollmentNew',
  },
  {
    path: '/confirm',
    name: 'EnrollmentConfirm',
  },
  {
    path: '/result',
    name: 'EnrollmentResult',
  },
]
